// Detecção de in-app browser / WebView a partir do user-agent.
// Usado APENAS para segmentar eventos de analytics (parâmetro is_webview /
// webview_app). Não muda comportamento de auth. WebViews embutidos (Instagram,
// Facebook, Gmail, etc.) frequentemente quebram OAuth e desafios de CAPTCHA, daí
// o interesse em isolar essa coorte no GA4.

function ua(): string {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return '';
  return navigator.userAgent;
}

// Apps conhecidos por abrirem links num WebView embutido. Ordem importa: o
// primeiro match vence (ex.: Instagram antes do Facebook, pois o UA do IG também
// pode conter FBAN/FBAV).
const APP_SIGNATURES: Array<{ app: string; test: RegExp }> = [
  { app: 'instagram', test: /Instagram/i },
  { app: 'facebook', test: /\bFBAN\b|\bFBAV\b|\bFB_IAB\b/i },
  { app: 'messenger', test: /Messenger/i },
  { app: 'tiktok', test: /\bBytedance\b|musical_ly|\bTikTok\b/i },
  { app: 'line', test: /\bLine\//i },
  { app: 'twitter', test: /\bTwitter\b/i },
  { app: 'snapchat', test: /Snapchat/i },
  { app: 'pinterest', test: /Pinterest/i },
  { app: 'linkedin', test: /LinkedInApp/i },
  { app: 'whatsapp', test: /WhatsApp/i },
  { app: 'google_app', test: /\bGSA\/\b/i },
  { app: 'kakao', test: /KAKAOTALK/i },
  { app: 'wechat', test: /MicroMessenger/i },
];

/**
 * Retorna true se a página parece estar rodando dentro de um WebView / in-app
 * browser, e não num navegador completo (Chrome/Safari/etc).
 */
export function isWebView(): boolean {
  const agent = ua();
  if (!agent) return false;

  // Android WebView: o token "; wv)" (ou " wv " em alguns devices).
  if (/;\s?wv\)|\bwv\b/.test(agent)) return true;

  // Apps conhecidos com WebView embutido.
  if (APP_SIGNATURES.some(({ test }) => test.test(agent))) return true;

  // iOS WKWebView: é iPhone/iPad/iPod, parece AppleWebKit, mas NÃO tem "Safari"
  // nem "CriOS"/"FxiOS" (que seriam Chrome/Firefox para iOS, navegadores reais).
  const isIOS = /iPhone|iPad|iPod/i.test(agent);
  if (isIOS && /AppleWebKit/i.test(agent) && !/Safari|CriOS|FxiOS|EdgiOS/i.test(agent)) {
    return true;
  }

  return false;
}

/**
 * Tenta identificar QUAL app embutiu o WebView (instagram, facebook, gmail...).
 * Retorna undefined quando não dá para identificar (inclusive quando não é WebView).
 */
export function getWebViewApp(): string | undefined {
  const agent = ua();
  if (!agent) return undefined;

  for (const { app, test } of APP_SIGNATURES) {
    if (test.test(agent)) return app;
  }

  if (isWebView()) return 'other';
  return undefined;
}
